import type { ReactNode } from 'react'
import React from 'react'
import map from 'lodash/map'
import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Spinner, TooltipPopOver } from '@ztechapps/webui.util'
import type { StatusBreadcrumbProviderProps } from './Context'
import { useStatusBreadcrumbContext, StatusBreadcrumbProvider } from './Context'

export const StatusBreaddrumb = (props: Omit<StatusBreadcrumbProviderProps, 'children'>) => {
  return (
    <StatusBreadcrumbProvider {...props}>
      <Layout />
    </StatusBreadcrumbProvider>
  )
}

const StatusBreadcrumbMenuItem = () => {
  const { statusMenu, loading, onUpdate, component } = useStatusBreadcrumbContext()

  return map(statusMenu, (item, key) => {
    return (
      <Dropdown.Item
        disabled={loading}
        key={key}
        eventKey={item?.value}
        onClick={async () => {
          await onUpdate(item.value)
        }}
      >
        <component.status status={item?.value} /> {item?.value}
      </Dropdown.Item>
    )
  })
}

const Layout = () => {
  const { loading, component, status } = useStatusBreadcrumbContext()
  const renderedMenuItem = component?.menuItem ? component.menuItem : <StatusBreadcrumbMenuItem />

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} size={'sm'} className={'py-0'} variant="outline-light" id="dropdown-basic">
        <HorizontalStack gap={1}>
          {loading && <Spinner size="sm" />}
          <component.statusBadge status={status} />
        </HorizontalStack>
      </Dropdown.Toggle>

      <Dropdown.Menu>{renderedMenuItem}</Dropdown.Menu>
    </Dropdown>
  )
}

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(
  ({ children, onClick }: { children: ReactNode; onClick: (e: any) => void }, ref: any) => {
    const { disabled, disabledReason } = useStatusBreadcrumbContext()

    // The disabled reason reads from `TooltipPopOver`, never a native `title`; an undefined body never opens.
    // `TooltipPopOver` clones the `<a>`, and react-bootstrap's `OverlayTrigger` merges the child's own `ref`
    // with its trigger ref, so the Dropdown's ref still lands on the `<a>`.
    return (
      <TooltipPopOver tooltipBody={disabled ? disabledReason : undefined}>
        <a
          href="/"
          ref={ref}
          onClick={(e) => {
            e.preventDefault()
            if (disabled) return

            onClick(e)
          }}
        >
          {children}
        </a>
      </TooltipPopOver>
    )
  }
)
